import { Link } from "react-router-dom";
import Head from "@/components/feature/Head";

export default function NotFound() {
  return (
    <>
      <Head
        title="页面未找到 - H漫画"
        description="您访问的页面不存在，请返回H漫画首页浏览更多精彩内容。"
        canonical="https://hahamanga.github.io"
      />
      <div className="min-h-[70vh] pt-20 flex flex-col items-center justify-center px-4 text-center">
        <div className="w-24 h-24 rounded-full bg-background-100 flex items-center justify-center mb-6">
          <i className="ri-emotion-sad-line text-4xl text-foreground-500 w-10 h-10 flex items-center justify-center"></i>
        </div>
        <h1 className="text-6xl font-heading font-bold text-primary-500 mb-3">404</h1>
        <p className="text-lg text-foreground-300 mb-2">抱歉，页面未找到</p>
        <p className="text-sm text-foreground-500 mb-8">您访问的页面可能已被移除或链接失效</p>
        <Link
          to="/"
          className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
    </>
  );
}